:host {
  --aha-tag--vertical-padding: 0.25em;
  --aha-tag--horizontal-padding: 0.35em;
  --aha-tag--font-size: inherit;
  --aha-tag--line-height: 1.1;
  --aha-tag--border-radius: var(--Common--border-radius);

  display: inline-block;
  border-radius: var(--aha-tag--border-radius);
  background-color: var(--aha-tag--color);
  padding: var(--aha-tag--vertical-padding) var(--aha-tag--horizontal-padding);
  font-size: var(--aha-tag--font-size);
  line-height: var(--aha-tag--line-height);
  color: var(--aha-tag--text-color);
}

:host([rounded]) {
  --aha-tag--horizontal-padding: 0.75em;
  --aha-tag--border-radius: 2em;
}
